import styled from 'styled-components';
import {IconButton} from '@material-ui/core';

export const IconButtonPrinter = styled(IconButton)`
  padding: 6px !important;
`;

export const OrdersTableWrapper = styled.div`
  .MuiTable-root {
    tr {
      &:first-child {
        th {
          &:nth-child(1) {
            width: 16%;
            @media (max-width: 1000px) {
              width: 15%;
            }
          }

          &:nth-child(2) {
            width: 10%;
          }

          &:nth-child(3) {
            width: 20%;
          }

          &:nth-child(4) {
            width: 18%;
            @media (max-width: 1000px) {
              width: 18%;
            }
          }

          //&:nth-child(4) {
          //  width: 14%;
          //  @media (max-width: 1000px) {
          //    width: 13%;
          //  }
          //}

          &:nth-child(5) {
            width: fit-content;
          }

          &:nth-child(6) {
            width: 13%;
          }

          &:nth-child(7) {
            width: 3%;
          }
        }
      }
    }
  }
`;
